var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "lead",
    attrs: { name: "agency-lead", "extra-class": "bottom-modal lead-modal" },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function(props) {
          return [
            _c("agency-lead-form", { attrs: { "agency-id": props.data } })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }